import React from 'react'
import { CellProps } from 'react-table'

import { LinkToInvoice } from './LinkToInvoice'
import { TableDataInvoice } from './types'

export const InvoiceCell: React.VFC<CellProps<TableDataInvoice>> = ({ row, value }) => (
  <LinkToInvoice invoiceId={row.original.invoiceId} value={value} />
)
